<template>
   <div class="container _margin-top-50">
      <div class="row">
         <div class="col-md-12 _margin-bottom-50">
            <h1>The quick brown fox jumps over the lazy dog</h1>
            <h2>The quick brown fox jumps over the lazy dog</h2>
            <h3>The quick brown fox jumps over the lazy dog</h3>
            <h4>The quick brown fox jumps over the lazy dog</h4>
            <h5>The quick brown fox jumps over the lazy dog</h5>
            <h6>The quick brown fox jumps over the lazy dog</h6>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
            <p>Tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
         </div>

         <div class="col-md-8">
            <div class="row _margin-bottom-50">
               <uiv-btn class="_margin-bottom-20" type="primary" size="lg" @click="submit">Search</uiv-btn>&nbsp;
               <uiv-btn class="_margin-bottom-20" type="primary" size="md" @click="submit">Search</uiv-btn>&nbsp;
               <uiv-btn class="_margin-bottom-20" type="primary" size="sm" @click="submit">Search</uiv-btn>&nbsp;
               <uiv-btn class="_margin-bottom-20" type="primary" size="xs" @click="submit">Search</uiv-btn>&nbsp;
               <uiv-btn
                  class="_margin-bottom-20"
                  type="primary"
                  size="xs"
                  disabled
                  @click="submit"
               >Search</uiv-btn>
               <br />
               <uiv-btn class="_margin-bottom-20" type="secondary" size="lg" @click="submit">Search</uiv-btn>&nbsp;
               <uiv-btn class="_margin-bottom-20" type="secondary" size="md" @click="submit">Search</uiv-btn>&nbsp;
               <uiv-btn class="_margin-bottom-20" type="secondary" size="sm" @click="submit">Search</uiv-btn>&nbsp;
               <uiv-btn class="_margin-bottom-20" type="secondary" size="xs" @click="submit">Search</uiv-btn>&nbsp;
               <uiv-btn
                  class="_margin-bottom-20"
                  type="secondary"
                  size="xs"
                  disabled
                  @click="submit"
               >Search</uiv-btn>
               <br />
               <uiv-btn class="_margin-bottom-20" type="passive" size="lg" @click="submit">Search</uiv-btn>&nbsp;
               <uiv-btn class="_margin-bottom-20" type="passive" size="md" @click="submit">Search</uiv-btn>&nbsp;
               <uiv-btn class="_margin-bottom-20" type="passive" size="sm" @click="submit">Search</uiv-btn>&nbsp;
               <uiv-btn class="_margin-bottom-20" type="passive" size="xs" @click="submit">Search</uiv-btn>&nbsp;
               <uiv-btn
                  class="_margin-bottom-20"
                  type="passive"
                  size="xs"
                  disabled
                  @click="submit"
               >Search</uiv-btn>
               <br />
               <uiv-btn class="_margin-bottom-20" type="danger" size="lg" @click="submit">Search</uiv-btn>&nbsp;
               <uiv-btn class="_margin-bottom-20" type="danger" size="md" @click="submit">Search</uiv-btn>&nbsp;
               <uiv-btn class="_margin-bottom-20" type="danger" size="sm" @click="submit">Search</uiv-btn>&nbsp;
               <uiv-btn class="_margin-bottom-20" type="danger" size="xs" @click="submit">Search</uiv-btn>&nbsp;
               <uiv-btn
                  class="_margin-bottom-20"
                  type="danger"
                  size="xs"
                  disabled
                  @click="submit"
               >Search</uiv-btn>
               <br />
               <uiv-btn class="_margin-bottom-20" type="ghost" size="lg" @click="submit">Search</uiv-btn>&nbsp;
               <uiv-btn class="_margin-bottom-20" type="ghost" size="md" @click="submit">Search</uiv-btn>&nbsp;
               <uiv-btn class="_margin-bottom-20" type="ghost" size="sm" @click="submit">Search</uiv-btn>&nbsp;
               <uiv-btn class="_margin-bottom-20" type="ghost" size="xs" @click="submit">Search</uiv-btn>&nbsp;
               <uiv-btn
                  class="_margin-bottom-20"
                  type="ghost"
                  disabled
                  size="xs"
                  @click="submit"
               >Search</uiv-btn>
            </div>

            <div class="row _margin-bottom-50">
               <loader :show="true"></loader>&nbsp;
               <uiv-btn class="_margin-bottom-20" type="primary" size="md">
                  <loader :show="true" />Search
               </uiv-btn>&nbsp;
               <uiv-btn class="_margin-bottom-20" type="secondary" size="md">
                  <loader :show="true" />Search
               </uiv-btn>&nbsp;
               <uiv-btn class="_margin-bottom-20" type="passive" size="md">
                  <loader :show="true" />Search
               </uiv-btn>&nbsp;
               <uiv-btn class="_margin-bottom-20" type="danger" size="md">
                  <loader :show="true" />Search
               </uiv-btn>&nbsp;
               <uiv-btn class="_margin-bottom-20" type="ghost" size="md">
                  <loader :show="true" />Search
               </uiv-btn>
            </div>

            <div class="row _margin-bottom-50">
               <div class="input-group right _margin-bottom-20">
                  <form-field id="postcode" v-model.trim="postcode" />

                  <div class="input-group-btn">
                     <uiv-btn type="primary" @click="submit">Search</uiv-btn>
                  </div>
               </div>

               <div class="input-group right _margin-bottom-20">
                  <form-field id="postcode" v-model.trim="postcode" />

                  <div class="input-group-addon">Pence/day</div>
               </div>

               <div class="input-group left _margin-bottom-30">
                  <div class="input-group-addon">£</div>
                  <form-field id="postcode" v-model.trim="postcode" />
               </div>

               <checkbox v-model="checkbox1" id="checkbox" inline>Checkbox 1</checkbox>&nbsp;
               <checkbox v-model="checkbox2" id="checkbox2" inline>Checkbox 2</checkbox>&nbsp;
               <checkbox v-model="checkbox3" id="checkbox3" disabled inline>Checkbox 3 (Disabled)</checkbox>
            </div>

            <div class="row _margin-bottom-50">
               <radio value="yes" v-model="radioValue" id="radio1" inline>Radio 1</radio>&nbsp;
               <radio value="no" v-model="radioValue" id="radio2" inline>Radio 2</radio>&nbsp;
               <radio
                  value="disabled"
                  v-model="radioValue"
                  id="radio3"
                  inline
                  disabled
               >Radio 3 (Disabled)</radio>
            </div>

            <div class="row _margin-bottom-50">
               <uiv-dropdown ref="dropdown">
                  <uiv-btn type="primary" class="dropdown-toggle">
                     Dropdown
                     <span class="caret"></span>
                  </uiv-btn>
                  <template slot="dropdown">
                     <li>
                        <a role="button">Action</a>
                     </li>
                     <li>
                        <a role="button">Another action</a>
                     </li>
                     <li>
                        <a role="button">Something else here</a>
                     </li>
                     <li role="separator" class="divider"></li>
                     <li>
                        <a role="button">Separated link</a>
                     </li>
                  </template>
               </uiv-dropdown>&nbsp;
               <uiv-dropdown ref="dropdown2">
                  <uiv-btn type="secondary" class="dropdown-toggle">
                     Dropdown
                     <span class="caret"></span>
                  </uiv-btn>
                  <template slot="dropdown">
                     <li>
                        <a role="button">Action</a>
                     </li>
                     <li>
                        <a role="button">Another action</a>
                     </li>
                     <li>
                        <a role="button">Something else here</a>
                     </li>
                     <li role="separator" class="divider"></li>
                     <li>
                        <a role="button">Separated link</a>
                     </li>
                  </template>
               </uiv-dropdown>&nbsp;
               <uiv-dropdown ref="dropdown3">
                  <uiv-btn type="passive" class="dropdown-toggle">
                     Dropdown
                     <span class="caret"></span>
                  </uiv-btn>
                  <template slot="dropdown">
                     <li>
                        <a role="button">Action</a>
                     </li>
                     <li>
                        <a role="button">Another action</a>
                     </li>
                     <li>
                        <a role="button">Something else here</a>
                     </li>
                     <li role="separator" class="divider"></li>
                     <li>
                        <a role="button">Separated link</a>
                     </li>
                  </template>
               </uiv-dropdown>&nbsp;
               <uiv-dropdown ref="dropdown4">
                  <uiv-btn type="danger" class="dropdown-toggle">
                     Dropdown
                     <span class="caret"></span>
                  </uiv-btn>
                  <template slot="dropdown">
                     <li>
                        <a role="button">Action</a>
                     </li>
                     <li>
                        <a role="button">Another action</a>
                     </li>
                     <li>
                        <a role="button">Something else here</a>
                     </li>
                     <li role="separator" class="divider"></li>
                     <li>
                        <a role="button">Separated link</a>
                     </li>
                  </template>
               </uiv-dropdown>&nbsp;
               <uiv-dropdown ref="dropdown5">
                  <uiv-btn type="ghost" class="dropdown-toggle">
                     Dropdown
                     <span class="caret"></span>
                  </uiv-btn>
                  <template slot="dropdown">
                     <li>
                        <a role="button">Action</a>
                     </li>
                     <li>
                        <a role="button">Another action</a>
                     </li>
                     <li>
                        <a role="button">Something else here</a>
                     </li>
                     <li role="separator" class="divider"></li>
                     <li>
                        <a role="button">Separated link</a>
                     </li>
                  </template>
               </uiv-dropdown>&nbsp;
               <uiv-navbar-nav>
                  <uiv-dropdown tag="li">
                     <a class="dropdown-toggle" role="button">
                        Dropdown 1
                        <span class="caret"></span>
                     </a>
                     <template slot="dropdown">
                        <li>
                           <a role="button">Action</a>
                        </li>
                        <li>
                           <a role="button">Another action</a>
                        </li>
                        <li>
                           <a role="button">Something else here</a>
                        </li>
                        <li role="separator" class="divider"></li>
                        <li>
                           <a role="button">Separated link</a>
                        </li>
                     </template>
                  </uiv-dropdown>
               </uiv-navbar-nav>
            </div>

            <div class="row _margin-bottom-50">
               <uiv-btn
                  v-uiv-popover.left="{title:'Title', content:'Popover on left'}"
                  type="primary"
               >Left</uiv-btn>&nbsp;
               <uiv-btn
                  v-uiv-popover.top="{title:'Title', content:'Popover on top'}"
                  type="primary"
               >Top</uiv-btn>&nbsp;
               <uiv-btn
                  v-uiv-popover.bottom="{title:'Title', content:'Popover on bottom'}"
                  type="primary"
               >Bottom</uiv-btn>&nbsp;
               <uiv-btn
                  v-uiv-popover.right="{title:'Title', content:'Popover on right'}"
                  type="primary"
               >Right</uiv-btn>
            </div>

            <div class="row _margin-bottom-50">
               <uiv-btn v-uiv-tooltip="'Static tooltip content goes here'" type="primary">Tooltip</uiv-btn>
            </div>

            <div class="row _margin-bottom-50">
               <uiv-multi-select v-model="selected" :options="options" block />
            </div>

            <div class="row _margin-bottom-50">
               <date-field
                  id="date"
                  v-model="date"
               />
            </div>

            <h2>Form Validation</h2>
            <div class="row _margin-bottom-50">
               <div class="col-md-12 _margin-bottom-20">
                  <validation-messages label="Date" :$v="$v.form.date">
                     <date-field
                        id="date"
                        v-model="form.date"
                        :error="$v.form.date.$error"
                     />
                  </validation-messages>
               </div>

               <div class="col-md-4 _margin-bottom-20">
                  <validation-messages label="Checkbox" :$v="$v.form.checkbox">
                     <checkbox v-model="form.checkbox" id="checkbox4" :error="$v.form.checkbox.$error">Checkbox</checkbox>
                  </validation-messages>
               </div>

               <div class="col-md-4">
                  <validation-messages label="Radio" :$v="$v.form.radio">
                     <radio value="yes" v-model="form.radio" id="radio4" inline :error="$v.form.radio.$error">Radio 1</radio>&nbsp;
                     <radio value="no" v-model="form.radio" id="radio5" inline :error="$v.form.radio.$error">Radio 2</radio>&nbsp;
                  </validation-messages>
               </div>

               <div class="col-md-4">
                  <validation-messages label="Text Field" :$v="$v.form.textField">
                     <form-field
                        id="textField"
                        v-model="form.textField"
                        :error="$v.form.textField.$error"
                     />
                  </validation-messages>
               </div>

               <div class="col-md-12 _margin-bottom-20">
                  <uiv-btn @click="vsubmit" type="primary">Submit</uiv-btn>
               </div>
            </div>

            <div class="row _margin-bottom-50">
               <uiv-alert type="success">
                  <b>Well done!</b> You successfully read this important alert message.
               </uiv-alert>
               <uiv-alert type="info">
                  <b>Heads up!</b> This alert needs your attention, but it's not super important.
               </uiv-alert>
               <uiv-alert type="warning">
                  <b>Warning!</b> Better check yourself, you're not looking too good.
               </uiv-alert>
               <uiv-alert type="danger">
                  <b>Oh snap!</b> Change this and that and try again.
               </uiv-alert>
            </div>

            <div class="row _margin-bottom-50">
               <uiv-btn @click="info" type="info">Info Notification (No Icon)</uiv-btn>&nbsp;
               <uiv-btn @click="success" type="success">Success Notification</uiv-btn>&nbsp;
               <uiv-btn @click="warning" type="warning">Warning Notification</uiv-btn>&nbsp;
               <uiv-btn @click="danger" type="danger">Danger Notification</uiv-btn>
            </div>

            <div class="row _margin-bottom-50">
               <uiv-tabs class="_margin-bottom-20" justified>
                  <uiv-tab title="Home">
                     <p>Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica. Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure terry richardson ex squid. Aliquip placeat salvia cillum iphone. Seitan aliquip quis cardigan american apparel, butcher voluptate nisi qui.</p>
                  </uiv-tab>
                  <uiv-tab title="Profile" disabled>
                     <p>Food truck fixie locavore, accusamus mcsweeney's marfa nulla single-origin coffee squid. Exercitation +1 labore velit, blog sartorial PBR leggings next level wes anderson artisan four loko farm-to-table craft beer twee. Qui photo booth letterpress, commodo enim craft beer mlkshk aliquip jean shorts ullamco ad vinyl cillum PBR. Homo nostrud organic, assumenda labore aesthetic magna delectus mollit. Keytar helvetica VHS salvia yr, vero magna velit sapiente labore stumptown. Vegan fanny pack odio cillum wes anderson 8-bit, sustainable jean shorts beard ut DIY ethical culpa terry richardson biodiesel. Art party scenester stumptown, tumblr butcher vero sint qui sapiente accusamus tattooed echo park.</p>
                  </uiv-tab>
                  <uiv-tab title="@vue" group="Dropdown">
                     <p>Etsy mixtape wayfarers, ethical wes anderson tofu before they sold out mcsweeney's organic lomo retro fanny pack lo-fi farm-to-table readymade. Messenger bag gentrify pitchfork tattooed craft beer, iphone skateboard locavore carles etsy salvia banksy hoodie helvetica. DIY synth PBR banksy irony. Leggings gentrify squid 8-bit cred pitchfork. Williamsburg banh mi whatever gluten-free, carles pitchfork biodiesel fixie etsy retro mlkshk vice blog. Scenester cred you probably haven't heard of them, vinyl craft beer blog stumptown. Pitchfork sustainable tofu synth chambray yr.</p>
                  </uiv-tab>
                  <uiv-tab title="@bootstrap" group="Dropdown">
                     <p>Trust fund seitan letterpress, keytar raw denim keffiyeh etsy art party before they sold out master cleanse gluten-free squid scenester freegan cosby sweater. Fanny pack portland seitan DIY, art party locavore wolf cliche high life echo park Austin. Cred vinyl keffiyeh DIY salvia PBR, banh mi before they sold out farm-to-table VHS viral locavore cosby sweater. Lomo wolf viral, mustache readymade thundercats keffiyeh craft beer marfa ethical. Wolf salvia freegan, sartorial keffiyeh echo park vegan.</p>
                  </uiv-tab>
               </uiv-tabs>

               <uiv-tabs pills justified>
                  <uiv-tab title="Home">
                     <p>Home tab.</p>
                  </uiv-tab>
                  <uiv-tab title="Profile">
                     <p>Profile tab.</p>
                  </uiv-tab>
                  <uiv-tab title="Others">
                     <p>Others tab.</p>
                  </uiv-tab>
               </uiv-tabs>
            </div>

            <div class="row _margin-bottom-50">
               <uiv-breadcrumbs :items="items" />
            </div>

            <div class="row _margin-bottom-50">
               <uiv-pagination v-model="currentPage" :total-page="totalPage" size="lg" />
               <uiv-pagination v-model="currentPage" :total-page="totalPage" />
               <uiv-pagination v-model="currentPage" :total-page="totalPage" size="sm" />
            </div>

            <div class="row _margin-bottom-50">
               <uiv-progress-bar v-model="progress" />
            </div>

            <div class="row _margin-bottom-50">
               <a href="#">
                  Inbox
                  <span class="badge">42</span>
               </a>
            </div>

            <div class="row _margin-bottom-50">
               <ul class="list-group">
                  <li class="list-group-item">Cras justo odio</li>
                  <li class="list-group-item">Dapibus ac facilisis in</li>
                  <li class="list-group-item">Morbi leo risus</li>
                  <li class="list-group-item">Porta ac consectetur ac</li>
                  <li class="list-group-item">Vestibulum at eros</li>
               </ul>
            </div>

            <div class="row _margin-bottom-50">
               <div class="panel panel-default">
                  <div class="panel-heading">Panel Title</div>
                  <div class="panel-body">Panel content</div>
               </div>
            </div>

            <div class="row _margin-bottom-50">
               <uiv-btn @click="modal = true" type="primary">Modal</uiv-btn>
               <uiv-modal
                  v-model="modal"
                  title="Are you sure?"
                  ok-text="Yes, please"
                  cancel-text="No way!"
                  ok-type="danger"
                  cancel-type="warning"
               >
                  <p>Do you really want to destroy this item?</p>
               </uiv-modal>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import { required, maxLength, maxValue } from 'vuelidate/lib/validators';

export default {
  name: 'Components',
  data () {
    return {
      postcode: '',
      checkbox1: false,
      checkbox2: false,
      checkbox3: false,
      radioValue: 'yes',
      date: null,
      selected: [],
      options: [
        { value: 1, label: 'Option 1' },
        { value: 2, label: 'Option 2' },
        { value: 3, label: 'Option 3' },
        { value: 4, label: 'Option 4' },
        { value: 5, label: 'Option 5' }
      ],
      items: [
        { text: 'Home', href: '#' },
        { text: 'Library', href: '#' },
        { text: 'Data', href: '#' }
      ],
      totalPage: 18,
      currentPage: 1,
      progress: 20,
      modal: false,
      form: {
        date: null,
        checkbox: null,
        dropdown: null,
        radio: null,
        textField: null
      }
    };
  },
  validations: {
    postcode: {
      required,
      maxLength: maxLength(50)
    },
    form: {
      date: { required },
      checkbox: { required },
      dropdown: { required },
      radio: { required },
      textField: { required }
    }
  },
  methods: {
    submit () {
      this.$v.$touch();

      if (this.$v.$invalid) {
      }
    },
    vsubmit () {
      this.$v.form.$touch();
    },
    info () {
      this.$uiv_notify({
        type: 'info',
        title: 'Heads up!',
        icon: '',
        content:
               "This alert needs your attention, but it's not super important."
      });
    },
    success () {
      this.$uiv_notify({
        type: 'success',
        title: 'Well done!',
        content: 'You successfully read this important alert message.'
      });
    },
    warning () {
      this.$uiv_notify({
        type: 'warning',
        title: 'Warning!',
        content: "Better check yourself, you're not looking too good."
      });
    },
    danger () {
      this.$uiv_notify({
        type: 'danger',
        title: 'Oh snap!',
        content: 'Change a few things up and try submitting again.'
      });
    }
  }
};
</script>

<style lang="scss">
</style>
